import React from 'react'
import { Helmet } from 'react-helmet'
import Navbar8 from '../components/navbar8'
import Hero8 from '../components/hero8'
import Timeline4 from '../components/timeline4'
import FAQ4 from '../components/faq4'
import Team7 from '../components/team7'
import Footer4 from '../components/footer4'
import './about.css'

const About = () => {
  const navLinks = ['Home', 'About Us', 'Initiatives', 'Members', 'Contact'].map((text, index) => (
    <span key={index} className={`about-text${index + 10} thq-body-small thq-link`}>{text}</span>
  ))

  const pages = ['One', 'Two', 'Three', 'Four'].map((text, index) => (
    <span key={index} className={`about-text${index + 14} thq-body-large`}>Page {text}</span>
  ))

  const pageDescriptions = pages.map((_, index) => (
    <span key={index} className={`about-text${index + 21} thq-body-small`}>Page {_ + 1} Description</span>
  ))

  return (
    <div className="about-container1">
    
      <Helmet>
        <title>CAIC: About Us</title>
        <meta property="og:title" content="CAIC: About Us" />
      </Helmet>
      <Navbar8
        link1={navLinks[0]} link2={navLinks[1]} link3={navLinks[2]} link4={navLinks[3]} link41={navLinks[4]}
        page1={pages[0]} page2={pages[1]} page3={pages[2]} page4={pages[3]}
        page1Description={pageDescriptions[0]} page2Description={pageDescriptions[1]}
        page3Description={pageDescriptions[2]} page4Description={pageDescriptions[3]}
        action1={<span className="about-text19">Main Action</span>}
        action2={<span className="about-text20">Secondary Action</span>}
        logoSrc="/screenshot%202024-07-31%20at%2013.58.42-1500h.png"
      />
      <Hero8
        content1={<span className="about-text25 thq-body-large">Empowering AI innovation across the Commonwealth</span>}
        heading1={<span className="about-text26 thq-heading-1">Welcome to the Commonwealth AI Consortium</span>}
        //videoSrc="namantapasvi.com"
        videoSrc="/video3.mp4"
      />
      <Timeline4
        date1={<span className="about-text27 thq-heading-3">April 2023</span>}
        date2={<span className="about-text28 thq-heading-3">August 2023</span>}
        date4={<span className="about-text29 thq-heading-3">September 2023</span>}
        card1Heading={<span className="about-text33 thq-heading-3">Formation of the Consortium</span>}
        card2Action1={<a href="https://thecommonwealth.org/ai-for-youth" className="about-text34" target="_blank" rel="noopener noreferrer">Learn More..</a>}
        card2Heading={<span className="about-text36 thq-heading-3">AI for Youth</span>}
        card4Action1={<a href="/initiatives" className="about-text37">View Details...</a>}
        card4Heading={<span className="about-text39 thq-heading-3">Launch of Multi-year initiatives</span>}
      />
      <div className="about-quote-container">
        <img
          alt="Secretary-General"
          src="https://production-new-commonwealth-files.s3.eu-west-2.amazonaws.com/s3fs-public/2023-10/DSC09891.jpg?VersionId=QM05f4ydaZ8HaC3bgAqNO8pzSAr1.9UR"
          className="about-image"
        />
        <blockquote className="about-quote" style={{ textAlign: 'justify'}}>
          <p>
            "Our focus on AI for good is not a passing phase; it is our pathway to inclusive growth, sustainable development, and shared prosperity for all our member countries. Our commitment to empowering women with digital skills is not casual; it is an imperative... Our focus on young people is not token, it based on a hard-headed assessment of the Commonwealth's demographic advantage, and an expression of our Charter… And our focus on small states is not peripheral, it is central – because 33 of the world's small states are in the Commonwealth."
          </p>
          <footer>- The Rt Hon Patricia Scotland KC, Secretary-General of the Commonwealth</footer>
        </blockquote>
      </div>
      <FAQ4 rootClassName="faq4root-class-name" />
      <Team7 rootClassName="team7root-class-name" /> 
      <Footer4 />

    </div>
  )
}

export default About
